import { b as r } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { definePartsStyle: o, defineMultiStyleConfig: t } = e(
  r.keys
), i = o({
  text: {
    color: "error.500",
    paddingX: 4,
    marginTop: 1,
    lineHeight: "16px",
    fontSize: "md"
  }
}), m = t({
  baseStyle: i
});
export {
  m as FormError
};
//# sourceMappingURL=FormError.es.js.map
